import React from 'react';
import { Grid } from '@material-ui/core';
import ChartCard from './ChartCard';

const style = {
  grid: {
    padding: '0 15px !important',
  },
};


function OrderStats(props) {
  return (
    <Grid className='stats-grid-container' container>
      <Grid className="stats-grid" lg={6} md={6} sm={6} xs={12}>
        <ChartCard
          chartColor="white"
          title="Average time to Ship"
          text={props.hoursToShip !== null ? `${props.hoursToShip} hours` : '-'}
          //  statIcon={AccessTime}
          statText="updated 4 minutes ago"
          type="spark"
        />
      </Grid>
      <Grid className="stats-grid" lg={6} md={6} sm={6} xs={12}>
        <ChartCard
          chartColor="white"
          title="Shipped on time"
          text={props.shippedOnTime ? `${props.shippedOnTime} %`: '-'}
          //  statIcon={AccessTime}
          statText="updated 4 minutes ago"
          type="spark"
        />
      </Grid>
      <Grid className="stats-grid" lg={6} md={6} sm={6} xs={12}>
        <ChartCard
          chartColor="white"
          title="Average order amount"
          text={props.averageOrderAmount ? `${props.averageOrderAmount} NZD` : '-'}
          //  statIcon={AccessTime}
          statText="updated 4 minutes ago"
          type="spark"
        />
      </Grid>
      <Grid className="stats-grid" lg={6} md={6} sm={6} xs={12}>
        <ChartCard
          chartColor="white"
          title="Total Orders"
          text={props.ordersCount ? props.ordersCount : '-'}
          //  statIcon={AccessTime}
          statText="updated 4 minutes ago"
          type="spark"
        />
      </Grid>
    </Grid>
  );
}

export default OrderStats;



// WEBPACK FOOTER //
// ./src/components/OrderStats.jsx